import {placeChildWizard, PlaceChildWizard} from "./PlaceChildOrderWizard";

export default angular.module("tfApp.portfolio.child-order-wizard", [])
                      .component(PlaceChildWizard, placeChildWizard())
                      .name;
